module.exports = __webpack_public_path__ + "img/1485345870.a23dbc65.jpg";